import { handleApi } from "..";
import {
  ADD_CONFERENCE,
  CONF_PARTICIPANTS,
  DELETE_CONFERENCE,
  GET_CONFERENCES,
  UPDATE_CONFERENCE,
  GET_CONFERENCE_EXEMPT,
  ADD_CONFERENCE_EXEMPT,
  DELETE_CONFERENCE_EXEMPT,
  MANUAL_CONFERENCE,
  CONFERENCE_PAID,
  CONFERENCE_REGISTER,
  CONFERENCE_NEEDS,
  PARTICIPANT_DELETE,
  CONFERENCE_FILTER,
  CONFERENCE_MANUAL_ADD,
  CONFERENCE_MANUAL_LIST,
  CONFERENCE_MANUAL_DELETE,
  CONFERENCE_TRANSPORT,
  CONFERENCE_CRECHE,
  CONFERENCE_MANUAL_APPROVE,
  SEARCH_CONFERENCE_EXEMPT,
  CONFERENCE_MISC_FILTER,
  CONFERENCE_NEEDS_FILTER,
} from "../../constants/api_constants";

export const getConference = async () => {
  return handleApi("get", GET_CONFERENCES);
};

export const addConference = async (values) => {
  return handleApi("post", ADD_CONFERENCE, values);
};

export const updateConference = async (values) => {
  return handleApi("put", `${UPDATE_CONFERENCE}/${values.id}`, values);
};

export const deleteConference = async (value) => {
  return handleApi("delete", `${DELETE_CONFERENCE}/${value}`);
};

export const manualConference = async (values) => {
  return handleApi("put", `${MANUAL_CONFERENCE}/${values.productId}`, values);
};

export const getConferenceParticipant = async (value) => {
  return handleApi("get", `${CONF_PARTICIPANTS}/${value}`);
};

export const getConferenceExempt = async () => {
  return handleApi("get", GET_CONFERENCE_EXEMPT);
};

export const addConferenceExempt = async (values) => {
  return handleApi("post", ADD_CONFERENCE_EXEMPT, values);
};

export const deleteConferenceExempt = async (value) => {
  return handleApi("delete", `${DELETE_CONFERENCE_EXEMPT}/${value}`);
};

export const searchConferenceExempt = async (value) => {
  return handleApi("post", `${SEARCH_CONFERENCE_EXEMPT}`, value);
};

export const conferencePaid = async (values) => {
  return handleApi("get", `${CONFERENCE_PAID}/${values.id}/${values.value}`);
};

export const conferenceRegister = async (values) => {
  return handleApi(
    "get",
    `${CONFERENCE_REGISTER}/${values.id}/${values.value}`
  );
};

export const conferenceNeeds = async (value) => {
  return handleApi("get", `${CONFERENCE_NEEDS}/${value}`);
};

export const deletePart = async (value) => {
  return handleApi("delete", `${PARTICIPANT_DELETE}/${value}`);
};

export const conferenceFilter = async (value) => {
  return handleApi("post", `${CONFERENCE_FILTER}/${value.category}`, value);
};

export const conferenceManualAdd = async (value) =>
  handleApi("post", CONFERENCE_MANUAL_ADD, value);

export const conferenceManualList = async (value) =>
  handleApi("get", `${CONFERENCE_MANUAL_LIST}/${value}`);

export const conferenceManualDelete = async (value) =>
  handleApi("delete", `${CONFERENCE_MANUAL_DELETE}/${value}`);

export const conferenceTransportList = async (value) =>
  handleApi("get", `${CONFERENCE_TRANSPORT}/${value}`);

export const conferenceCrecheList = async (value) =>
  handleApi("get", `${CONFERENCE_CRECHE}/${value}`);

export const conferenceManualApprove = async (value) =>
  handleApi("get", `${CONFERENCE_MANUAL_APPROVE}/${value}`);

export const conferenceMiscFilter = async (value) =>
  handleApi("post", `${CONFERENCE_MISC_FILTER}`, value);

export const conferenceNeedsFilter = async (value) =>
  handleApi("post", `${CONFERENCE_NEEDS_FILTER}`, value);
